<template>
  <div>
    <!-- Admin Delete Dancer Confirmation Modal -->
    <div v-if="showDeleteDancerModal" class="mdl-overlay" @click.self="$emit('close-delete-dancer')">
      <div class="mdl-card shadow-lg p-4" style="max-width: 500px; width: 90%;">
        <div class="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom modal-header-border">
          <div class="d-flex align-items-center gap-3">
            <div class="topup-icon-badge" style="background: rgba(239, 68, 68, 0.15); color: #ef4444;">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
              </svg>
            </div>
            <div>
              <h4 class="mb-0 fw-bold text-danger">Táncos végleges törlése</h4>
              <p class="modal-subtitle-text small mb-0">Adminisztrátori művelet</p>
            </div>
          </div>
          <button class="btn btn-sm modal-close-btn rounded-circle" @click="$emit('close-delete-dancer')" style="width: 32px; height: 32px; padding: 0;">✕</button>
        </div>

        <div class="mb-4">
          <p class="mb-2 modal-title-text">Biztosan törölni szeretnéd a következő táncost az adatbázisból?</p>
          <div class="delete-target-card mb-3">
            <strong class="text-danger fs-5">{{ (childInfo && childInfo.childxfamily_name) ? (childInfo.childxfamily_name + ' ' + childInfo.childxsure_name) : 'Kiválasztott táncos' }}</strong>
            <div v-if="childInfo && childInfo.eventGroupName" class="modal-subtitle-text small mt-1">Csoport: {{ childInfo.eventGroupName }}</div>
          </div>
          <p class="small text-danger mb-0">
            <strong>Figyelem:</strong> A művelet nem vonható vissza! A táncoshoz kapcsolódó jelenléti ívek, csoporttagságok és egyéb rekordok véglegesen törlődnek.
          </p>
        </div>

        <div class="d-flex justify-content-end gap-2 pt-2 border-top modal-footer-border">
          <button type="button" class="modern-btn modern-btn--secondary" @click="$emit('close-delete-dancer')" :disabled="isDeletingDancer">
            Mégse
          </button>
          <button type="button" class="modern-btn modern-btn--danger" @click="$emit('confirm-delete-dancer')" :disabled="isDeletingDancer">
            <span v-if="isDeletingDancer">Törlés folyamatban...</span>
            <span v-else>Igen, táncos törlése</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Parent / Dancer Request Deletion Modal -->
    <div v-if="showDeleteRequestModal" class="mdl-overlay" @click.self="$emit('close-delete-request')">
      <div class="mdl-card shadow-lg p-4" style="max-width: 520px; width: 90%;">
        <div class="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom modal-header-border">
          <div class="d-flex align-items-center gap-3">
            <div class="topup-icon-badge" style="background: rgba(239, 68, 68, 0.15); color: #ef4444;">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                <line x1="10" y1="11" x2="10" y2="17"/>
                <line x1="14" y1="11" x2="14" y2="17"/>
              </svg>
            </div>
            <div>
              <h4 class="mb-0 fw-bold modal-title-text">Törlés kérelmezése az admintól</h4>
              <p class="modal-subtitle-text small mb-0">{{ (childInfo && childInfo.childxfamily_name) ? (childInfo.childxfamily_name + ' ' + childInfo.childxsure_name) : 'Táncos' }} részére</p>
            </div>
          </div>
          <button class="btn btn-sm modal-close-btn rounded-circle" @click="$emit('close-delete-request')" style="width: 32px; height: 32px; padding: 0;">✕</button>
        </div>

        <form @submit.prevent="submitRequest">
          <div class="mb-3">
            <p class="small modal-subtitle-text mb-2">
              A kérelem beküldése után az iskola adminisztrátorai e-mailben kapnak értesítést a kérésről és annak indoklásáról.
            </p>
            <label class="form-label small fw-semibold modal-label-text mb-1">Törlés indoklása (opcionális)</label>
            <textarea
              v-model="deleteReason"
              class="form-control modern-input modal-input-field"
              rows="4"
              placeholder="Kérjük, írd le a törlés okát (pl. költözés, egyéb elfoglaltság stb.)..."
              :disabled="isSubmittingDeleteRequest"
            ></textarea>
          </div>

          <div class="d-flex justify-content-end gap-2 pt-2 border-top modal-footer-border">
            <button type="button" class="modern-btn modern-btn--secondary" @click="$emit('close-delete-request')" :disabled="isSubmittingDeleteRequest">
              Mégse
            </button>
            <button type="submit" class="modern-btn modern-btn--danger" :disabled="isSubmittingDeleteRequest">
              <span v-if="isSubmittingDeleteRequest">Küldés...</span>
              <span v-else>Kérelem elküldése</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChildDeleteModals',
  props: {
    showDeleteDancerModal: {
      type: Boolean,
      default: false
    },
    isDeletingDancer: {
      type: Boolean,
      default: false
    },
    showDeleteRequestModal: {
      type: Boolean,
      default: false
    },
    isSubmittingDeleteRequest: {
      type: Boolean,
      default: false
    },
    childInfo: {
      type: Object,
      default: null
    }
  },
  emits: [
    'close-delete-dancer',
    'confirm-delete-dancer',
    'close-delete-request',
    'submit-delete-request'
  ],
  data() {
    return {
      deleteReason: ''
    };
  },
  methods: {
    submitRequest() {
      this.$emit('submit-delete-request', this.deleteReason);
      this.deleteReason = '';
    }
  }
};
</script>

<style scoped>
.mdl-overlay {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  padding: 1.5rem 1rem;
  z-index: 99999;
}

.mdl-card {
  background: var(--card-bg) !important;
  color: var(--color-text) !important;
  border: 1px solid var(--color-border) !important;
  border-radius: 20px !important;
  box-shadow: 0 20px 30px -10px rgba(0, 0, 0, 0.45), 0 10px 15px -5px rgba(0, 0, 0, 0.3) !important;
  position: relative;
  overflow: hidden;
  margin: auto;
  max-height: calc(100vh - 3rem);
}

.modal-header-border {
  border-bottom: 1px solid var(--color-border);
}

.modal-footer-border {
  border-top: 1px solid var(--color-border);
}

.topup-icon-badge {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.modal-title-text {
  color: var(--color-heading);
}

.modal-subtitle-text {
  color: var(--color-text-muted);
}

.modal-label-text {
  color: var(--color-heading);
}

.delete-target-card {
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.25);
  border-radius: 12px;
  padding: 1rem;
}

.modal-close-btn {
  background: var(--color-background-soft);
  color: var(--color-text-muted);
  border: 1px solid var(--color-border);
}

.modal-input-field {
  background-color: var(--card-bg);
  color: var(--color-text);
  border: 1.5px solid var(--color-border);
}

[data-theme="dark"] .delete-target-card {
  background: rgba(239, 68, 68, 0.15) !important;
  border-color: rgba(239, 68, 68, 0.35) !important;
}

[data-theme="dark"] .modal-header-border {
  border-bottom-color: #334155 !important;
}

[data-theme="dark"] .modal-footer-border {
  border-top-color: #334155 !important;
}

[data-theme="dark"] .modal-title-text {
  color: #f8fafc !important;
}

[data-theme="dark"] .modal-subtitle-text {
  color: #94a3b8 !important;
}

[data-theme="dark"] .modal-label-text {
  color: #cbd5e1 !important;
}

[data-theme="dark"] .modal-input-field {
  background-color: #0f172a !important;
  color: #f8fafc !important;
  border-color: #334155 !important;
}

[data-theme="dark"] .modal-close-btn {
  background-color: #334155 !important;
  color: #cbd5e1 !important;
  border-color: #475569 !important;
}
</style>
